<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { ViewConfig } from '../services/view';
    import { format } from 'date-fns';
    
    export let view: ViewConfig;
    export let projectId: string;
    export let canEdit: boolean = false;
    export let canDelete: boolean = false;

    console.log('view', view);
    
    const dispatch = createEventDispatcher<{
      edit: ViewConfig;
      delete: ViewConfig;
      viewNetwork: ViewConfig;
      copyEmbed: ViewConfig;
      copyNetworkLink: ViewConfig;
    }>();
    
    $: formattedDate = view.createdAt ? format(new Date(view.createdAt), 'd, MMM, yyyy') : '';
    $: formattedUpdated = view.updatedAt ? format(new Date(view.updatedAt), 'd, MMM, yyyy') : '';
    
    function viewNetwork(event: Event) {
      event.stopPropagation();
      dispatch('viewNetwork', view);
    }
    
    function copyEmbedLink(event: Event) {
      event.stopPropagation();
      dispatch('copyEmbed', view);
    }
    
    function copyNetworkLink(event: Event) {
      event.stopPropagation();
      dispatch('copyNetworkLink', view);
    }
    
    function editView(event: Event) {
      event.stopPropagation();
      dispatch('edit', view);
    }
    
    function deleteView(event: Event) {
      event.stopPropagation();
      dispatch('delete', view);
    }
  </script>
  
  <div class="view-card">
    <div class="view-thumbnail">
      {#if view.thumbnail}
        <img src={view.thumbnail} alt="View thumbnail" />
      {:else}
        <div class="no-thumbnail">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.09 8.26L19 7L16.73 12.73L23 12L16.73 17.27L19 23L13.09 21.74L12 28L10.91 21.74L5 23L7.27 17.27L1 12L7.27 6.73L5 1L10.91 2.26L12 2Z" fill="currentColor"/>
          </svg>
        </div>
      {/if}
    </div>
    
    <div class="view-content">
      <h3 class="view-title">{view.name}</h3>
      {#if view.description}
        <p class="view-description">{view.description}</p>
      {/if}
      <p class="view-description">Visibility Level: {view.adminLevel || 'none'}</p>
      
      <div class="view-meta">
        <span class="meta-item">Created: {formattedDate}</span>
        {#if view.updatedAt && view.updatedAt !== view.createdAt}
          <span class="meta-item">Updated: {formattedUpdated}</span>
        {/if}
        <span class="meta-item">By: {view.createdBy || 'Unknown'}</span>
      </div>
    </div>
    
    <!-- Main Action Buttons -->
    <div class="main-actions">
      <button class="main-action-btn view-btn" title="View Network" on:click={viewNetwork}>
        
        <span>View Network</span>
      </button>

      <button class="main-action-btn copy-network-btn" title="Copy Network Link" on:click={copyNetworkLink}>
       
        <span>Copy Link</span>
      </button>

      <button class="main-action-btn copy-embed-btn" title="Copy Embed Link" on:click={copyEmbedLink}>
        
        <span>Copy Embed</span>
      </button>
    </div>

    <!-- Edit/Delete Actions (top right corner) -->
    {#if canEdit || canDelete}
      <div class="view-actions">
        {#if canEdit}
          <button class="action-btn edit-btn" title="Edit view" on:click={editView}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="currentColor"/>
              <path d="m20.71 7.04-2.79-2.79c-.39-.39-1.02-.39-1.41 0l-2.13 2.13 3.75 3.75 2.67-2.67.01-.01c.4-.4.4-1.03 0-1.43z" fill="currentColor"/>
            </svg>
          </button>
        {/if}
        
        {#if canDelete}
          <button class="action-btn delete-btn" title="Delete view" on:click={deleteView}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3-14V2h6v3h5v2H2v-2h5z" fill="currentColor"/>
            </svg>
          </button>
        {/if}
      </div>
    {/if}
  </div>
  
  <style>
    .view-card {
      background: white;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 16px;
      transition: all 0.2s ease;
      position: relative;
      overflow: hidden;
    }
    
    .view-card:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border-color: #d0d0d0;
    }
    
    .view-thumbnail {
      width: 100%;
      height: 120px;
      background: #f5f5f5;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 12px;
    }
    
    .view-thumbnail img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .no-thumbnail {
      color: #999;
    }
    
    .view-content {
      flex: 1;
    }
    
    .view-title {
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 8px 0;
      color: #333;
      line-height: 1.3;
    }
    
    .view-description {
      color: #666;
      font-size: 14px;
      margin: 0 0 12px 0;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    
    .view-meta {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-bottom: 12px;
    }
    
    .meta-item {
      font-size: 12px;
      color: #888;
    }
    
    .main-actions {
      display: flex;
      flex-direction: row;
      gap: 8px;
      margin-top: 16px;
    }

    .main-action-btn {
      padding: 8px 12px;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.2s ease;
      font-size: 14px;
      font-weight: 500;
      width: 100%;
      justify-content: flex-start;
    }

    .main-action-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .view-btn {
      background: #f0fdf4;
      color: #16a34a;
      border: 1px solid #bbf7d0;
    }
    
    .view-btn:hover {
      background: #dcfce7;
      color: #15803d;
    }

    .copy-network-btn {
      background: #eff6ff;
      color: #2563eb;
      border: 1px solid #bfdbfe;
    }
    
    .copy-network-btn:hover {
      background: #dbeafe;
      color: #1d4ed8;
    }

    .copy-embed-btn {
      background: #fef3c7;
      color: #d97706;
      border: 1px solid #fed7aa;
    }
    
    .copy-embed-btn:hover {
      background: #fed7aa;
      color: #c2410c;
    }

    .view-actions {
      position: absolute;
      top: 12px;
      right: 12px;
      display: flex;
      gap: 8px;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    
    .view-card:hover .view-actions {
      opacity: 1;
    }
    
    .action-btn {
      width: 32px;
      height: 32px;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
    }
    
    .edit-btn {
      background: #f0f9ff;
      color: #0369a1;
    }
    
    .edit-btn:hover {
      background: #e0f2fe;
      color: #0c4a6e;
    }
    
    .delete-btn {
      background: #fef2f2;
      color: #dc2626;
    }
    
    .delete-btn:hover {
      background: #fee2e2;
      color: #b91c1c;
    }
  </style>